/**
 * Piezas de UI compartidas por las dos pantallas de importación de asignaciones
 * (relojes checadores y turnos). Van aparte de `importarAsignaciones.utils.js`
 * porque ésas son puras (se prueban en node) y estas ya traen React y antd.
 */

import React from "react";
import { Modal, Tag } from "antd";

const OPERACIONES = {
  crear: { texto: "Crear", color: "green" },
  habilitar: { texto: "Habilitar", color: "blue" },
  deshabilitar: { texto: "Deshabilitar", color: "orange" },
  reemplazar: { texto: "Reemplazar", color: "purple" },
  // Sólo los usa "Agregar Varias" de Asignación de Turnos.
  reactivar: { texto: "Reactivar", color: "blue" },
  extender: { texto: "Extender", color: "cyan" },
  sinCambios: { texto: "Sin cambios", color: "default" },
};

// Columna de la vista previa que dice, renglón por renglón, qué se va a hacer.
// El valor viene del campo `operacion` que pone el validador.
export const columnaOperacion = {
  title: "Operación",
  dataIndex: "operacion",
  key: "operacion",
  width: 120,
  fixed: "left",
  render: (valor) => {
    const operacion = OPERACIONES[valor];
    if (!operacion) return valor || "—";
    return <Tag color={operacion.color}>{operacion.texto}</Tag>;
  },
};

// Etiquetas de la columna "Acción" y del Alert de resumen de
// ImportadorExcelGenerico. "editar" cubre habilitar/deshabilitar/reemplazar, y el
// detalle de cuál es lo dice la columna "Operación".
export const ETIQUETAS_ACCION = {
  crear: "Crear",
  editar: "Cambio",
  sinCambios: "Sin cambios",
};

/**
 * Muestra el detalle de los renglones que el servidor no pudo aplicar.
 *
 * Se pasa como `onImportSuccess`: devolver true hace que ImportadorExcelGenerico
 * NO navegue hacia atrás, así que sólo se devuelve true cuando hay algo que el
 * usuario tiene que leer. Con todo bien devuelve false y la pantalla se cierra
 * como siempre.
 */
export const mostrarResumenImportacion = (resData, { entidad } = {}) => {
  const fallidos = (resData?.resultados || []).filter((r) => r && !r.ok);

  if (fallidos.length === 0 && !resData?.incompleto) return false;

  Modal.info({
    title: "Resultado de la importación",
    width: 720,
    okText: "Entendido",
    content: (
      <div style={{ marginTop: 12 }}>
        <p style={{ marginBottom: 12 }}>
          Se aplicaron <b>{resData?.numeroCreados ?? 0}</b> altas y{" "}
          <b>{resData?.numeroEditados ?? 0}</b> cambios
          {entidad ? ` de ${entidad}` : ""}.
        </p>

        {resData?.incompleto && (
          <p style={{ color: "#ff4d4f", marginBottom: 12 }}>
            El envío se detuvo antes de terminar: se procesaron{" "}
            {resData.procesadas ?? 0} de {resData.totalFilas ?? 0} filas.
            {resData.mensajeError ? ` ${resData.mensajeError}.` : ""} Vuelve a
            descargar la plantilla y sube sólo lo que falte.
          </p>
        )}

        {fallidos.length > 0 && (
          <>
            <p style={{ marginBottom: 8 }}>
              <b>{fallidos.length}</b>{" "}
              {fallidos.length === 1 ? "renglón no se aplicó" : "renglones no se aplicaron"}:
            </p>
            <div style={{ maxHeight: 320, overflowY: "auto" }}>
              <ul style={{ paddingLeft: 20, margin: 0 }}>
                {fallidos.map((resultado, i) => (
                  <li key={i} style={{ marginBottom: 6 }}>
                    <b>{resultado.etiqueta || "(sin identificar)"}</b>{" "}
                    <span style={{ color: "#8c8c8c" }}>
                      ({OPERACIONES[resultado.operacion]?.texto || resultado.operacion})
                    </span>
                    {resultado.message ? ` — ${resultado.message}` : ""}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
    ),
  });

  return true;
};
